import BaseService from "@/services/BaseService";

export default class AcceptanceRuleCarrierService extends BaseService {
  constructor() {
    super("insurance_pricing/acceptance_rules");
  }

  findAllByAcceptanceRuleId(acceptanceRuleId, data) {
    return this.http.get(`${this._serviceName}/${acceptanceRuleId}/carriers`, {
      params: data,
    });
  }

  save(acceptanceRuleId, data) {
    return this.http.post(
      `${this._serviceName}/${acceptanceRuleId}/carriers`,
      data
    );
  }

  delete(acceptanceRuleId, id) {
    return this.http.delete(
      `${this._serviceName}/${acceptanceRuleId}/carriers/${id}`
    );
  }

  update(acceptanceRuleId, id, data) {
    return this.http.put(`${this._serviceName}/${acceptanceRuleId}/carriers/${id}`, data)
  }
}
